import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Button, Select, MenuItem, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { storeState } from "../../Redux/Slice/dataSlice";

const MainHeader = () => {
  const [items, setItems] = useState([
    { label: "All State", value: "All State" },
    { label: "Abuja", value: "Abuja" },
    { label: "Abia", value: "Abia" },
    { label: "Adamawa", value: "Adamawa" },
    { label: "Akwa Ibom", value: "Akwa Ibom" },
    { label: "Anambra", value: "Anambra" },
    { label: "Bauchi", value: "Bauchi" },
    { label: "Bayelsa", value: "Bayelsa" },
    { label: "Benue", value: "Benue" },
    { label: "Borno", value: "Borno" },
    { label: "Cross River", value: "Cross River" },
    { label: "Delta", value: "Delta" },
    { label: "Ebonyi", value: "Ebonyi" },
    { label: "Edo", value: "Edo" },
    { label: "Ekiti", value: "Ekiti" },
    { label: "Enugu", value: "Enugu" },
    { label: "Gombe", value: "Gombe" },
    { label: "Imo", value: "Imo" },
    { label: "Jigawa", value: "Jigawa" },
    { label: "Kaduna", value: "Kaduna" },
    { label: "Kano", value: "Kano" },
    { label: "Katsina", value: "Katsina" },
    { label: "Kebbi", value: "Kebbi" },
    { label: "Kogi", value: "Kogi" },
    { label: "Kwara", value: "Kwara" },
    { label: "Lagos", value: "Lagos" },
    { label: "Nasarawa", value: "Nasarawa" },
    { label: "Niger", value: "Niger" },
    { label: "Ogun", value: "Ogun" },
    { label: "Ondo", value: "Ondo" },
    { label: "Osun", value: "Osun" },
    { label: "Oyo", value: "Oyo" },
    { label: "Plateau", value: "Plateau" },
    { label: "Rivers", value: "Rivers" },
    { label: "Sokoto", value: "Sokoto" },
    { label: "Taraba", value: "Taraba" },
    { label: "Yobe", value: "Yobe" },
    { label: "Zamfara", value: "Zamfara" },
  ]);
  const [selectedValue, setSelectedValue] = useState("All State");
  const [getData, setData] = useState("");
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const dispatch = useDispatch();

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    dispatch(storeState(event?.target?.value));
    // localStorage.setItem("userstate", event?.target?.value);
    // console.log("event.target.value", event.target.value);
  };

  // useEffect(() => {
  //   const getState = localStorage.getItem("userstate");
  //   setData(getState);
  // }, []);

  // console.log("getData", getData);

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#0077E5", zIndex: 10 }}>
      <Toolbar sx={{ padding: "0 20px" }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1 }}>
          <Select
            value={selectedValue}
            onChange={handleSelectChange}
            displayEmpty
            fullWidth
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              zIndex: 20,
              width: "300px",
              padding: "10px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              fontSize: "1rem",
              "& .MuiSelect-icon": {
                right: "10px",
              },
            }}
          >
            <MenuItem value="" disabled style={{ padding: "10px" }}>
              Select State
            </MenuItem>
            {items.map((item) => (
              <MenuItem key={item?.value} value={item?.value}>
                {item?.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainHeader;
